<div class="tile-section" [class.elevated]="elevated">
  <div *ngIf="headerKey" class="header">
    <b>{{ headerKey | locCap }}</b>
  </div>
  <ng-content></ng-content>
</div>
